import { Routes } from "@angular/router";

import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";

export const AppRoutes: Routes = [
  {
    path: "",
    component: AdminLayoutComponent,
    children: [
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        loadChildren: "./dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "settings/company",
        loadChildren:
          "./components/company-management/company-management.module#CompanyManagementModule",
      },
      {
        path: "settings/app",
        loadChildren:
          "./components/app-management/app-management.module#AppManagementModule",
      },
      {
        path: "settings/unit",
        loadChildren:
          "./components/unit-management/unit-management.module#UnitManagementModule",
      },
      {
        path: "settings/gdpr",
        loadChildren:
          "./components/gdpr-management/gdpr.module#GdprManagementModule",
      },
      {
        path: "settings/category",
        loadChildren:
          "./components/category-management/category-management.module#CategoryManagementModule",
      },
      {
        path: "settings/user",
        loadChildren:
          "./components/user-management/user-management.module#UserManagementModule",
      },
      {
        path: "settings/alluser",
        loadChildren:
          "./components/users-management/users-management.module#UsersManagementModule",
      },
      {
        path: "contactus",
        loadChildren:
          "./components/contactus-management/contactus-management.module#ContactusManagementModule",
      },
      {
        path: "news",
        loadChildren:
          "./components/news-management/news-management.module#NewsManagementModule",
      },
      {
        path: "event",
        loadChildren:
          "./components/event-management/event-management.module#EventManagementModule",
      },
      {
        path: "faq",
        loadChildren:
          "./components/faq-management/faq-management.module#FaqManagementModule",
      },
      {
        path: "link",
        loadChildren:
          "./components/link-management/link-management.module#LinkManagementModule",
      },
      {
        path: "like",
        loadChildren:
          "./components/like-management/like-management.module#LikeManagementModule",
      },
      {
        path: "forms",
        loadChildren:
          "./components/form-management/form-management.module#FormManagementModule",
      },
      {
        path: "offer",
        loadChildren:
          "./components/offer-management/offer-management.module#OfferManagementModule",
      },
      {
        path: "checklist",
        loadChildren:
          "./components/checklist-management/checklist-management.module#ChecklistManagementModule",
      },
      {
        path: "contact",
        loadChildren:
          "./components/contact-management/contact-management.module#ContactManagementModule",
      },
      {
        path: "notification",
        loadChildren:
          "./components/notification-management/notification-management.module#NotificationManagementModule",
      },
      {
        path: "settings/agreement",
        loadChildren:
          "./components/agreement-management/agreement-management.module#AgreementManagementModule",
      },
      {
        path: "settings/smsstatistics",
        loadChildren:
          "./components/smsstatistics-management/smsstatistics-management.module#SMSStatisticsManagementModule",
      },
      {
        path: 'settings/setting',
        loadChildren: './components/settings-management/settings-management.module#SettingsManagementModule'
      },
      {
        path: "settings/website",
        loadChildren:
          "./components/website-management/website-management.module#WebsiteManagementModule",
      },
      {
        path: 'settings/festivaltheme',
        loadChildren: './components/festival-theme-management/festival-theme-management.module#FestivalThemeManagementModule'
      },
      {
        path: 'error-reporting',
        loadChildren: './components/error-reporting-management/error-reporting-management.module#ErrorReportingManagementModule'                  
      },
    ],
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "privacy/:id",
        loadChildren:
          "./components/privacy-management/privacy-management.module#PrivacyManagementModule",
      },
      {
        path: "login",
        loadChildren:
          "./authentication/authentication.module#AuthenticationModule",
      },
      {
        path: "forgot",
        loadChildren:
          "./authentication/authentication.module#AuthenticationModule",
      },
      {
        path: "authentication",
        loadChildren:
          "./authentication/authentication.module#AuthenticationModule",
      },
      {
        path: "resetpassword/:id/:code",
        loadChildren:
          "./components/reset-management/reset-management.module#ResetManagementModule",
      },
      {
        path: "resetpassword",
        loadChildren:
          "./components/reset-management/reset-management.module#ResetManagementModule",
      },
    ],
  },
  {
    path: "**",
    redirectTo: "error/404",
  },
];



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/app.routing.ts